module.exports = __webpack_public_path__ + "static/media/logo.7f0d2dc2.png";